export enum ExceptionQueueStatuses {
    Pending = 1,
    Resolved = 2,
    Canceled = 3
}